export default function initM45() {
  $(function() {
    if($('.module-m45').length > 0) {
      $('.module-m45').find('.module-m45-card').each(function() {
        let card = $(this);
        let wrapper = $(card).find('.wrapper');
        let paragraph = $(card).find('p');
        var hover = false;

        $(card).on("mouseenter", function() {
          hover = true;
          
          $(wrapper).css('opacity', '0');
          card.addClass('active');
        }).on("mouseleave", function() {
          hover = false;

          if ($(wrapper).opcaity != 1 && $(paragraph).css('opacity') != 1) {
            $(wrapper).css('opacity', '1');
          }

          $(paragraph).css('opacity', '0');
          card.removeClass('active');
        });

        $(wrapper).on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {
          if(hover) {
            $(wrapper).css('height', '0');
            $(paragraph).css('opacity', '1');
          }
        });

        $(paragraph).on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {
          if(!hover) {
            $(wrapper).css('height', '100%');
            $(wrapper).css('opacity', '1');
          }
        });

      });
    }
  });
}
